import {
    AccountCategory,
    type HolisticSummaryCategory,
    type SpendAccountCategory,
} from '@fruitful/types';
import { router } from 'expo-router';
import * as React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    LandmarkIcon,
    Sheet,
    YStack,
} from 'smoothie';

export interface Props {
    isOpen: boolean;
    onClose: () => void;
    launchInstitutionConnector: () => void;
    holisticCategory?: HolisticSummaryCategory;
    spendType?: SpendAccountCategory;
}

export const AddInstitutionSheet = ({
    isOpen,
    onClose,
    launchInstitutionConnector,
    holisticCategory,
    spendType,
}: Props) => {
    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Add an account"
            showCloseButton
        >
            <YStack
                flex={1}
                marginTop={16}
                marginHorizontal={4}
                minWidth={300}
                gap={8}
            >
                <Button
                    icon={LandmarkIcon}
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Link an account"
                    onPress={() => {
                        launchInstitutionConnector();
                    }}
                />
                <Button
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    text="Add manually-tracked account"
                    onPress={() => {
                        onClose();
                        router.navigate({
                            pathname: '/holistic/manual-accounts/create',
                            params: {
                                category:
                                    holisticCategory != null
                                        ? holisticCategory.valueOf()
                                        : undefined,
                                type:
                                    spendType != null &&
                                    holisticCategory === AccountCategory.SPEND
                                        ? spendType.valueOf()
                                        : undefined,
                            },
                        });
                    }}
                />
            </YStack>
        </Sheet>
    );
};
